
import {  createSlice } from "@reduxjs/toolkit"
import {  stateEnum } from "../constants/enum"
const { cerditDebitNote } = stateEnum

let initialState = {
  billno: "",
  acid: "",
  detailParams: [],
  isCreditNote: false,
  isNewEntry: true,
}

const creditNoteSlice = createSlice({
  name: cerditDebitNote,
  initialState,
  reducers: {
    setIsCreditNote: (state, action) => {
      state.isCreditNote = action.payload
    },
    resetValues: (state) => {
      state.billno = ""
      state.acid = ""
      state.detailParams = []
      state.isCreditNote = false
      state.isNewEntry = true
    },
    setNewEntryMode: (state, action) => {
      state.isNewEntry = action.payload
    },
    setDetailParams: (state, action) => {
      state.detailParams = action.payload
    },
    resetDetailParams: (state) => {
      state.detailParams = []
      state.isNewEntry = true
      state.isCreditNote = false
      state.billno = ""
      state.acid = ""

    },
  },

})

export const {
  setIsCreditNote,
  resetValues,
  setNewEntryMode,
  setDetailParams,
  resetDetailParams
} = creditNoteSlice.actions
export default creditNoteSlice.reducer

